import styled from 'styled-components';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';

export const MiniOrbitUsefulLinksListBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 15px 0;

    ${CssRule.For.mobile.tablet.build()} & {
        padding: 0;
    }
`;